export interface CountryCoordsItem {
	lat: number
	lng: number
	name: string
	name_cz: string
}

export interface CountryCoords {
	[key:string]: CountryCoordsItem
}

const countryCoordiantes: CountryCoords = {
	AT: {
		lat: 47.33333333,
		lng: 13.33333333,
		name: 'Austria',
		name_cz: 'Rakousko'
	},
	BE: { lat: 50.83333333, lng: 4, name: 'Belgium', name_cz: 'Belgie' },
	BG: { lat: 43, lng: 25, name: 'Bulgaria', name_cz: 'Bulharsko' },
	CH: { lat: 47, lng: 8, name: 'Switzerland', name_cz: 'Švýcyrsko' },
	CZ: {
		lat: 49.75,
		lng: 15.5,
		name: 'Czech Republic',
		name_cz: 'Česká republika'
	},
	DE: { lat: 51, lng: 9, name: 'Germany', name_cz: 'Německo' },
	DK: { lat: 56, lng: 10, name: 'Denmark', name_cz: 'Dánsko' },
	EE: { lat: 59, lng: 26, name: 'Estonia', name_cz: 'Estonsko' },
	ES: { lat: 40, lng: -4, name: 'Spain', name_cz: 'Španělsko' },
	FI: { lat: 64, lng: 26, name: 'Finland', name_cz: 'Finsko' },
	FR: { lat: 46, lng: 2, name: 'France', name_cz: 'Francie' },
	GR: { lat: 39, lng: 22, name: 'Greece', name_cz: 'Řecko' },
	HR: { lat: 45.16666666, lng: 15.5, name: 'Croatia', name_cz: 'Chorvatsko' },
	HU: { lat: 47, lng: 20, name: 'Hungary', name_cz: 'Maďarsko' },
	IE: { lat: 53, lng: -8, name: 'Ireland', name_cz: 'Irsko' },
	IT: { lat: 42.83333333, lng: 12.83333333, name: 'Italy', name_cz: 'Itálie' },
	LT: { lat: 56, lng: 24, name: 'Lithuania', name_cz: 'Litva' },
	LV: { lat: 57, lng: 25, name: 'Latvia', name_cz: 'Lotyšsko' },
	NL: { lat: 52.5, lng: 5.75, name: 'Netherlands', name_cz: 'Nizozemsko' },
	PL: { lat: 52, lng: 20, name: 'Poland', name_cz: 'Polsko' },
	PT: { lat: 39.5, lng: -8, name: 'Portugal', name_cz: 'Portugalsko' },
	RO: { lat: 46, lng: 25, name: 'Romania', name_cz: 'Rumunsko' },
	RU: { lat: 60, lng: 100, name: 'Russia', name_cz: 'Rusko' },
	SE: { lat: 62, lng: 15, name: 'Sweden', name_cz: 'Švédsko' },
	SI: {
		lat: 46.11666666,
		lng: 14.81666666,
		name: 'Slovenia',
		name_cz: 'Slovinsko'
	},
	SK: { lat: 48.66666666, lng: 19.5, name: 'Slovakia', name_cz: 'Slovensko' },
	UA: { lat: 49, lng: 32, name: 'Ukraine', name_cz: 'Ukrajina' },
	UK: { lat: 54, lng: -2, name: 'United Kingdom', name_cz: 'Velká Británie' }
}

export default countryCoordiantes
